module.exports = __webpack_public_path__ + "static/img/can-mangolime-bublyburst.e23e0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-mangolime-bublyburst.png
// module id = O1QD
// module chunks = 0